import ImmutableModel from '../immutable.model';

/**
 * A service retrieved from the backend.
 */
class Service extends ImmutableModel {
  /**
   * @param {Number} id
   * @param {String} name
   * @param {Number} order
   * @param {Number} duration
   * @param {Boolean} featured
   * @param {Boolean} acute
   * @param {Boolean} is_default Should this Service be offered by default
   * @param {String} description
   * @param {String} estimated_duration
   * @param {List.<String>} patient_instructions
   * @param {List.<String>} service_attentions
   * @param {String} price Normal price.
   * @param {String} kela_price Price after kela compensations if available.
   * @param {String} combined_price Combination of Normal and Kela price.
   * @param {String} price_info Additional info regarding the price.
   * @param {Boolean} is_starting_price Is the price a "starting from" price.
   * @param {Array.<Number>} categories
   * @param {Array.<Number>} groups
   * @param {Boolean} internet_reservable Is this reservable from internet
   * @param {String} url Url for service on website
   */
  constructor(
    id,
    name,
    order,
    duration,
    featured,
    acute,
    is_default,
    description,
    estimated_duration,
    patient_instructions,
    service_attentions,
    price,
    kela_price,
    combined_price,
    price_info,
    is_starting_price,
    categories,
    groups,
    internet_reservable,
    url,
  ) {
    super();

    this.id = id;
    this.name = name;
    this.order = order;
    this.duration = duration;
    this.featured = featured;
    this.acute = acute;
    this.is_default = is_default;
    this.description = description;
    this.estimated_duration = estimated_duration;
    this.patient_instructions = patient_instructions;
    this.service_attentions = service_attentions;
    this.price = price;
    this.kela_price = kela_price;
    this.combined_price = combined_price;
    this.price_info = price_info;
    this.is_starting_price = is_starting_price;
    this.categories = categories;
    this.groups = groups;
    this.internet_reservable = internet_reservable;
    this.url = url;
  }

  copy() {
    return new Service(
      this.id,
      this.name,
      this.order,
      this.duration,
      this.featured,
      this.acute,
      this.is_default,
      this.description,
      this.estimated_duration,
      this.patient_instructions,
      this.service_attentions,
      this.price,
      this.kela_price,
      this.combined_price,
      this.price_info,
      this.is_starting_price,
      this.categories,
      this.groups,
      this.internet_reservable,
      this.url,
    );
  }
}

export default Service;



// WEBPACK FOOTER //
// ./src/app/common/models/service.model.js